import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

function RoleUserCard(props) {
    const removeRoleUser = () => {
        console.log("Removing role user: " + JSON.stringify(props.userRole));
        props.remove(props.userRole.roleID, props.userRole.userID);
    };

    const roleUserJSX = (
        <div className="role-user card  item-details">
            <div className="properties">
                <div className="svg-label">
                    <i className="fas fa-envelope"></i>
                    <span>{props.userRole.user.emailAddress}</span>
                </div>
            </div>
            <div className="actions-horizontal">
                <div onClick={removeRoleUser} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faTrashAlt} />
                </div>
            </div>
        </div>
    );

    return roleUserJSX;
}

export default RoleUserCard;